import { CacheStrategy } from '@rammetec/data-access';
import { addressFieldDescriptors } from './_addressFields.js';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { FACTORY } from '../types/factory.js';
import { WORK_CALENDAR } from '../types/work-calendar.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Factory entity (productive plant — not a fiscal establishment).
 * Stored in 'org/{orgId}/factory'.
 */
export const factoryDescriptor = {
    name: FACTORY,
    label: 'Fábrica',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/factory',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 2,
    description: 'Productive plant / factory (unit of production, not a fiscal establishment)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique factory identifier',
        },
        {
            name: 'code',
            example: 1,
            label: 'Código',
            type: 'number',
            display: 'code',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric factory code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            example: 'Fábrica Blumenau',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Factory description',
        },
        // Standard address block, reference mode (spec 0047 §4.1 / D22) — the same
        // nine fields as Party and the CD. The plant had no address field before
        // request 0252, so this adds nine columns and renames none: no orphan.
        // PostgresRest entity — the columns only exist after `system-api build` and
        // a restart (`verifiedTables` is an in-memory Set).
        ...addressFieldDescriptors(),
        {
            name: 'notes',
            example: 'Unidade principal — Rua das Indústrias, 1200',
            label: 'Observações',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.NOTES,
            description: 'Free-text notes',
        },
        {
            name: 'workCalendarId',
            label: 'Calendário de trabalho',
            type: 'string',
            required: false,
            description: 'Optional work calendar (default journey for resources of this plant)',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'workCalendarId',
            targetEntity: WORK_CALENDAR,
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Optional work calendar for this factory',
        },
    ],
};
//# sourceMappingURL=factory.descriptor.js.map